import { useMemo } from 'react';

import classNames from 'classnames';

import { BootstrapTable } from '@components/Table/Table';

export const TotalUnbilledTrafficTable = ({ data }) => {
  const columns = useMemo(
    () => [
      {
        id: 'date',
        Header: 'Unbilled including',
        accessor: 'until_date',
        className: 'col-md-2',
      },
      { Header: 'Currency', accessor: 'currency', className: 'col-md-1' },
      {
        Header: 'Inbound',
        accessor: 'total_inbound_traffic',
        className: 'col-md-2',
      },
      {
        Header: 'Outbound',
        accessor: 'total_outbound_traffic',
        className: 'col-md-2',
        setMinWidth: '90px',
      },
      {
        Header: 'Total unbilled',
        accessor: 'total_unbilled',
        className: 'col-md-2',
        setMinWidth: '90px',
      },
    ],
    []
  );
  return (
    <BootstrapTable
      columns={columns}
      data={data}
      tableProps={() => ({ responsive: true, borderless: true })}
      headerProps={() => ({ className: 'text-center' })}
      rowProps={(row) => ({
        className: classNames({
          'border-bottom': row.isExpanded,
        }),
      })}
      cellProps={() => ({ className: 'text-center' })}
    />
  );
};
